import { createAsyncThunk } from '@reduxjs/toolkit'
import { getSms } from 'feature/auth/api'
import { phones } from 'helpers/phones'
import { RootState } from 'store/types'
import { Severity, addNotification } from 'widget/Notifications'

import { SmsBlockType, SmsStatus, authActions } from '../authSlice'

// получаем смс (для авторизации)
export const getAuthSms = createAsyncThunk<void, string, { state: RootState }>(
  'auth/getAuthSms',
  (phone, { dispatch }) => {
    dispatch(authActions.setAuthInfo({ isLoading: true }))
    getSms({
      phone: `+${phones(phone)}`,
    })
      .then(({ data }) => {
        dispatch(
          authActions.setUserInfo({
            isDataAgreeRequired:
              data.signAgreementProcessingPersonalDataRequired,
          }),
        )
        if (data.blockedTime !== 0) {
          dispatch(
            authActions.setSmsInfo({
              error: null,
              blockTime: data.blockedTime,
              blockType: SmsBlockType.countLimit,
            }),
          )
        } else
          dispatch(
            authActions.setSmsInfo({
              error: null,
              status: SmsStatus.sendedCode,
              blockTime: data.retryAfter,
              blockType: SmsBlockType.timeNotRunout,
            }),
          )
      })
      .catch(error => {
        const message =
          error?.response?.data?.message ||
          'Не удалось отправить код. Попробуйте позже.'
        dispatch(addNotification({ severity: Severity.error, text: message }))
      })
      .finally(() => {
        dispatch(authActions.setAuthInfo({ isLoading: false }))
      })
  },
)
